"use strict";

// import '@babel/polyfill';

import $ from 'jquery';

// import LazyLoad from 'vanilla-lazyload';

// SimpleShare
import SimpleShare from './plugins/simpleshare/index';

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

import { layer } from './plugins/layer/index';

import '@splidejs/splide/css';
import Splide from '@splidejs/splide';
// import { Grid } from '@splidejs/splide-extension-grid';

// import imagesLoaded from 'imagesloaded';
// import jQueryBridget from 'jquery-bridget';
// import Masonry from 'masonry-layout';
// jQueryBridget('masonry', Masonry, $);

// import validate from 'jquery-validation';
// import axios from 'axios';

// gsap
// import {gsap} from 'gsap';
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// gsap.registerPlugin(ScrollTrigger);

// import * as CookieConsent from 'vanilla-cookieconsent';
// import 'vanilla-cookieconsent/dist/cookieconsent.css';

// Lenis

import Lenis from 'lenis';

import './iconfont/iconfont';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";


import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

// import 'altcha';


(() => {


	// 测试用
	const domLoop = document.querySelectorAll('[data-loop]');
	if (domLoop) {
		domLoop.forEach(item => {
			const len = item.getAttribute('data-loop');
			const sourceItem = item.innerHTML;
			for (let i = 0; i < len; i++) {
				// console.log(item.innerHTML);
				// item.appendChild(item.innerHTML);
				item.innerHTML += sourceItem
			}
		});
	}
	

	const $body = document.body;
	const lenis = new Lenis();

	lenis.on('scroll', ({ animatedScroll, limit, velocity, direction, progress }) => {
		animatedScroll > 60 ? $body.classList.add('fixed-menu') : $body.classList.remove('fixed-menu')
		direction > 0 ? $body.classList.add('drop-menu') : $body.classList.remove('drop-menu')
	});

	function raf(time) {
		lenis.raf(time);
		requestAnimationFrame(raf);
	}

	requestAnimationFrame(raf);


	const menuOpen = document.querySelector('.js-menu-open');
	const menuClose = document.querySelector('.js-menu-close');
	menuOpen.addEventListener('click', function(){
		document.body.classList.add('menu-open');
	});
	menuClose.addEventListener('click', function(){
		document.body.classList.remove('menu-open');
	});
	

	$('.hm-item').on('mouseenter', function(){
		const subM = $(this).find('.hms-box');
		if (subM) {
			$(this).addClass('active');
			subM.stop().slideDown(300);
		}
	});
	$('.hm-item').on('mouseleave', function(){
		const subM = $(this).find('.hms-box');
		if (subM) {
			$(this).removeClass('active');
			subM.stop().slideUp(300);
		}
	});

})();


(() => {
	if (document.querySelector('.js-splide-ib')) {
		const splideIb = new Splide('.js-splide-ib', {

		}).mount();
	}

	$('.apply-download').on('mouseenter', function(){
		$('.apply-download').removeClass('current');
		$(this).addClass('current');
	})

	if (document.querySelector('.js-splide-goodsd')) {
		const splideGoodsd = new Splide('.js-splide-goodsd', {

		}).mount();
	}


	$('.js-etime-tab span').on('click', function(){
		const index = $(this).index();
		$(this).addClass('current').siblings().removeClass('current');
		$('.etime-ul').addClass('hidden');
		$('.etime-ul').eq(index).removeClass('hidden');
	});

	$('.faq-item__header').on('click', function(){

		const i = $(this).parents('.faq-item').index();

		$('.faq-item').each(function(index, item){
			const body = $(item).find('.faq-item__body');
			if (i === index) {
				if ($(item).hasClass('active')) {
					$(item).removeClass('active');
					body.slideUp(300);
				} else {
					$(item).addClass('active');
					body.slideDown(300);
				}
			} else {
				if ($(item).hasClass('active')) {
					$(item).removeClass('active');
					body.slideUp(300);
				}
			}
		});

		// $('.faq-item').eq(0).trigger('click');
		
	});

})();

// INIT
(() => {
	// Lazyload data-src data-bg data-poster
	// var myLazyLoad = new LazyLoad({
	// 	threshold: 800
	// });

	// Social Share
	const share = new SimpleShare({
		url: '',
		title: '',
		content: '',
		pic: ''
	});
	const shareLinks = document.querySelectorAll('[data-share]');
	shareLinks.forEach(link => {
		link.addEventListener('click', () => {
			share.goShare(link.getAttribute('data-share'));
		})
	});

	AOS.init({
		duration: 800,
		offset: 50
	});

	Fancybox.bind("[data-fancybox]", {
		// Your custom options
	});

	const plyrelms = document.querySelectorAll('.plyr-v');
	for ( var i = 0; i < plyrelms.length; i++ ) {
		const player = new Plyr( plyrelms[i] );
	}
	

	$(document).on('click', '.js-lartist-close', function(){
		const box = $(this).parents('.layer-artist');
		box.fadeOut(300, function() {
			box.remove();
		});
	});

	const artistHTML = `<div class="layer-artist fixed inset-0 z-1000">
			<div class="absolute inset-0 flex justify-center items-center">
				<div class="w-full">
					<div class="max-w-1000 mx-auto">
						<div class="lartist-body bg-white relative">
							<svg class="js-lartist-close lartist-close text-hd24 hd:text-24 w-[1.25em] h-[1.25em] absolute top-[.8em] right-[.8em] cursor-pointer"><use xlink:href="#icon-close"></use></svg>
							<div class="lartist-article absolute top-hd80 hd:top-80 bottom-hd80 hd:bottom-80 right-hd60 hd:right-60 left-hd60 hd:left-60 overflow-y-auto" data-lenis-prevent>

								<!-- 1000*660 -->
								<div class="splide splide-goodsd js-splide-goodsd-layer splide-dots" role="group" aria-label="" data-splide='{"arrows": false}'>
									<div class="splide__track">
										<ul class="splide__list" data-loop="2">
											<li class="splide__slide">
												<a href="assets/images/placeholder.webp" data-fancybox class="goodsd-ban block img-box relative bg-black3">
													<img class="absolute top-0 left-0 w-full h-full object-cover" src="assets/images/placeholder.webp" alt="">
												</a>
											</li>
										</ul>
									</div>
								</div>

								<!-- 视频封面 1000*560， 视频尺寸 1280*720 -->
								<div class="plyr-video relative mt-hd30 hd:mt-30">
									<video class="plyr-v-layer opacity-0" playsinline controls data-poster="assets/images/placeholder.webp">
										<source src="upload/media/video.mp4" type="video/mp4" />
									</video>
								</div>

								<div class="h-1 bg-black mt-hd60 hd:mt-60"></div>

								<!-- 480*480 -->
								<div class="lartist-img img-box relative bg-black3 mt-hd60 hd:mt-60 mx-auto">
									<img class="absolute top-0 left-0 w-full h-full object-cover" src="assets/images/placeholder.webp" alt="">
								</div>

								<h2 class="text-hd32 hd:text-32 font-700 leading-1 mt-hd60 hd:mt-60">Shinya Azuma</h2>

								<div class="text-18 mt-hd30 hd:mt-30">
									<p>Graduated from the Department of Fine Arts, National Kaohsiung Normal University</p>
									<p>&nbsp;</p>
									<p>The works are mainly presented with acrylic paint, using a large-area flat painting technique, retaining the texture of the canvas itself in a small amount of multiple layers; then adding dislocated lines that overflow the composition itself. In previous works, lines were used to “destroy the original structure of the picture”, but in recent works, lines are used as “colors to enhance the fun”, combining color blocks with brushstrokes, line stacking, and paint debris to simulate the atmosphere of pop art in the 1960s in terms of visual effects.</p>
									<p>&nbsp;</p>
									<p>As an artist in the 21st century, it is easy to obtain abundant social resources in life, and you can quickly explore various information. While receiving a large amount of information, you will feel lost in cultural belonging. With this side effect, under the impact of existing cultural heritage and new culture, you seem to be a middleman and nomad.
									</p>
									<p>&nbsp;</p>
									<p>Nomads, naked bodies become a specific painting language, and they are regarded as symbols, combining new and old cultural vocabulary into one carrier. Wherever the naked body goes, it is equipped with the most advantageous conditions seen by the eyes, forming a new myth with nomadic colors.</p>
									<p>&nbsp;</p>
									<p>As a “new myth”, the work hides sharp doubts and uneasiness under the colorful and joyful picture; it attempts to reflect the absurdity under the impact of the new myth, or the vanity of human desire. The colorful and frizzy beasts and the desires transformed into arrows confront each other on the picture, making the body intertextual with them. This intertextuality provides a pulling and wrestling force. When integrated, it seems like a crazy and gorgeous feast for the viewer, chaotic and arrogant.</p>
								</div>

								<div class="mt-hd40 hd:mt-40 flex gap-x-hd text-hd20 hd:text-20 gap-x-[.75em]">
									<a href="" class="lartist-share">
										<svg><use xlink:href="#icon-facebook"></use></svg>
									</a>
									<a href="" class="lartist-share">
										<svg><use xlink:href="#icon-twitter"></use></svg>
									</a>
									<a href="" class="lartist-share">
										<svg><use xlink:href="#icon-linkedin"></use></svg>
									</a>
								</div>


								<div class="h-1 bg-black mt-hd40 hd:mt-40"></div>

								<div class="mt-hd40 hd:mt-40">
									<div>
										<h3 class="text-hd24 hd:text-24 font-500">Exhibitions</h3>
										<div class="text-hd16 hd:text-16 mt-hd20 hd:mt-20">
											<p class="font-700 italic">Solo Exhibition</p>
											<p>2023 “The Madness never ends”，Artelli Art Space，澳门，中国</p>
											<p>2023 “Garden of eden” ，Maison Ozmen ，巴黎，法国</p>
											<p>2023 “IN FLAMES”，333Gallery，台北微风南山，台湾</p>
											<p>2022 “99 PROBLEMS” ，333Gallery ，台北，台湾</p>
											<p>&nbsp;</p>
											<p class="font-700 italic">Group Exhibition</p>
											<p>2023 “EXPRESSIONS” SR GALERIE，巴黎，法国</p>
											<p>2023 “COAST”，Stupid Krap，黄金海岸，澳大利亚</p>
											<p>2022 “Being and Time” ，宝龙艺术中心，上海，中国</p>
											<p>2022 “Leaves May Fall” ，Maison Ozmen ，巴黎，法国</p>
											<p>2022 “Above & Beyond Kawaii “，Dorothy Circus，英国伦敦，义大利罗马</p>
											<p>2021 「艺术新声」，台中市大墩文化中心，台中，台湾</p>
											<p>2020 「今晚，我想来点⋯」，116 艺术中心，高雄，台湾</p>
											<p>2019 「在那一刻按下暂停键」，116 艺术中心，高雄，台湾</p>
											<p>2018 「渐/至之间」，高雄市文化中心，高雄，台湾</p>
											<p>&nbsp;</p>
											<p class="font-700 italic">Art Fair</p>
											<p>2023/10 ART TAIPEI 台北国际艺术博览会，台北世贸中心，台北，台湾</p>
											<p>2023/6 Affordable Art Fair Shanghai上海冉起当代艺术博览会，上海展览中心，上海，中国</p>
											<p>2022/10 ART TAIPEI 台北国际艺术博览，台北世贸中心，台北，台湾</p>
											<p>2022/5 TAIPEI DANGDAI台北当代艺术博览会，台北世贸中心，台北，台湾</p>
											<p>2022/3 ART TAINAN 台南艺术博览会，晶英酒店，台南，台湾</p>
											<p>2022/1 ART FUTURE 艺术未来博览会，君悦酒店，台北，台湾</p>
											<p>2021/12 ONEOFFS NFT 国际艺术博览会，W Taipei，台北，台湾</p>
											<p>2021/11 ART KAOHSIUNG 高雄艺术博览会，城市商旅真爱馆，高雄，台湾</p>
											<p>2021/9 ART FORMOSA 福尔摩沙国际艺术博览会，诚品行旅，台北，台湾</p>
										</div>
									</div>

									<div class="mt-hd50 hd:mt-50">
										<h3 class="text-hd24 hd:text-24 font-500">Auctions</h3>
										<div class="text-hd16 hd:text-16 mt-hd20 hd:mt-20">
											<p>2022 “BREAK IN EMERGENCY 3″， 4BYSIX Group Exhibition，伦敦，Online</p>
										</div>
									</div>

									<div class="mt-hd50 hd:mt-50">
										<h3 class="text-hd24 hd:text-24 font-500">Interview</h3>
										<div class="text-hd16 hd:text-16 mt-hd20 hd:mt-20">
											<p>2023 GQ Jan/Feb</p>
											<p>2022 PRESTIGE杂志No.118</p>
											<p>2022 东西名人杂志No.180</p>
										</div>
									</div>

									<div class="mt-hd50 hd:mt-50">
										<h3 class="text-hd24 hd:text-24 font-500">Event</h3>
										<div class="text-hd16 hd:text-16 mt-hd20 hd:mt-20">
											<p>2023 “m̄asquerade” menomeno x 朱晨维，商品联名</p>
											<p>2023 「2023山海艺术节—基隆乐夏天」海洋Café by 微笑PARA ，PARA x 朱晨维，联名艺术创作</p>
											<p>2023 「Legends 传奇人物」AREA 02 x 朱晨维，艺术创作、周边商品与服饰联名</p>
											<p>2023 「尝试！创造未来！」StrangeLove x 朱晨维，Mocktai商品联名</p>
											<p>2022 “YUniwonderland” YUYU ACTIVE x 朱晨维，服饰联名</p>
											<p>2022 TED x TaipeiFuhsingPrivateSchool”游戏攻略” ，台北，台湾</p>
										</div>
									</div>

									<div class="mt-hd50 hd:mt-50">
										<h3 class="text-hd24 hd:text-24 font-500">Publish</h3>
										<div class="text-hd16 hd:text-16 mt-hd20 hd:mt-20">
											<p>2023 由Stupid Krap发行限量版画</p>
											<p>2022 由Stupid Krap发行限量版画</p>
										</div>
									</div>

									<div class="h-1 bg-black mt-hd60 hd:mt-60"></div>
									
								</div>


							</div>
						</div>
					</div>
				</div>
			</div>
		</div>`;
	$('.list-iartist span').on('click', function() {
		// $('body').append(artistHTML);

		// $('.layer-artist').removeClass('opacity-0');


		const layerHtml = document.createElement('div');
		layerHtml.innerHTML = artistHTML;

		document.body.appendChild(layerHtml);

		if (layerHtml.querySelector('.js-splide-goodsd-layer')) {
			const splideGoodsd = new Splide('.js-splide-goodsd-layer', {

			}).mount();
		}

		if (layerHtml.querySelector('.plyr-v-layer')) {
			const elm = layerHtml.querySelector('.plyr-v-layer');
			const player = new Plyr( elm );
		}
	});

	// let str = ''
	// for (let i = 1; i < 21; i++) {
	// 	str += `'${i * 10}': '${i * 10}px',\n'hd${i * 10}': '${((i * 10)/22.4).toFixed(4)}vw',\n`
	// }

	// let fontsize = [12, 14, 16, 18, 20, 24, 26, 28, 30, 32, 36, 40, 48, 54, 60, 68, 72, 120, 200];
	// let str = '';
	// for (let i = 0; i < fontsize.length; i++) {
	// 	str += `'${fontsize[i]}': '${fontsize[i]}px',\n'hd${fontsize[i]}': '${(fontsize[i]/19.2).toFixed(4)}vw',\n`
	// }
	// console.log(str);

	// let spaceArr = [1, 5, 6, 10, 12, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 140, 160, 180, 200];
	// let space = '';
	// for (let i = 0; i < spaceArr.length; i++) {
	// 	space += `'${spaceArr[i]}': '${spaceArr[i]}px',\n'hd${spaceArr[i]}': '${(spaceArr[i]/19.2).toFixed(4)}vw',\n`
	// }
	// console.log('spacing:');
	// console.log(space);


})();

// CookieConsent
(() => {
	/**
	 * All config. options available here:
	 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
	*/
	document.documentElement.classList.add('cc--defaultmode');
	
	CookieConsent.run({

		categories: {
			necessary: {
				enabled: true,  // this category is enabled by default
				readOnly: true  // this category cannot be disabled
			},
			required: {
				enabled: true,  // this category is enabled by default
				readOnly: false  // this category cannot be disabled
			},
			analytics: {}
		},

		guiOptions: {
			consentModal: {
				layout: 'bar',
				position: 'bottom',
				flipButtons: false,
				equalWeightButtons: true
			},
			preferencesModal: {
				layout: 'box',
				// position: 'left right',
				flipButtons: false,
				equalWeightButtons: true
			}
		},

		language: {
			default: 'en',

			translations: {
				en: {

					consentModal: {
						title: '',
						description: 'We use our own and third-party cookies to ensure the proper functioning of the web portal and its complements, perform navigation analysis and show multimedia content. If you continue browsing, you accept the use of this technology. For more information please see our Cookies Policy. <a href="/cookie-statement" style="text-decoration:underline;">Learn more</a>',
						acceptAllBtn: 'Accept all',
						acceptNecessaryBtn: 'Reject all',
						showPreferencesBtn: 'Customize'
					},
					preferencesModal: {
						title: 'Manage cookie preferences',
						acceptAllBtn: 'Save settings',
						acceptNecessaryBtn: 'Reject all',
						savePreferencesBtn: 'Accept current selection',
						closeIconLabel: 'Close modal',
						sections: [
							// {
							// 	title: 'Somebody said ... cookies?',
							// 	description: 'I want one!'
							// },
							{
								title: 'Technically required',
								description: 'Required web technologies and cookies make our website technically accessible to and usable for you. This applies to fundamental base functionalities such as navigation on the website, correct display in your internet browser or requesting your consent. Without these web technologies and cookies our website does not work.',

								//this field will generate a toggle linked to the 'required' category
								linkedCategory: 'required'
							},
							{
								title: 'Analysis and statistics',
								description: 'We want to constantly improve the user-friendliness and performance of our websites. For this reason we use analysis technologies (including cookies) which pseudonymously measure and evaluate which functions and content of our websites are used, how and how often. On this basis we can improve our websites for users.',
								linkedCategory: 'analytics'
							}
							// ,
							// {
							// 	title: 'More information',
							// 	description: 'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>'
							// }
						]
					}
				}
			}
		}
	});
});